import { mobiClient } from '@/services/axiosConfig'
import { UnitGroupRes, UnitListReq } from './types'

export const getUnitList = async (req: UnitListReq): Promise<UnitGroupRes | undefined> => {
  try {
    const headers = {
      isdn: req.isdn
    }
    const res = await mobiClient.get('/unit', { headers })
    return res.data
  } catch (e) {
    console.error('fetch data list failed', e)
  }
}
